













































import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: {
    url: {
      required: true,
      type: String
    },
    prompt: {
      type: Boolean,
      required: false,
      default: (): boolean => true
    }
  },

  data() {
    return {
      saving: false,
      error: false,
      dragging: false,
      preview: null as null | string
    };
  },

  computed: {
    imageSource(): string {
      if (this.preview) {
        return this.preview;
      }

      if (this.url) {
        return this.url;
      }

      return require("../images/profile--upload-picture.svg");
    },

    inputField(): HTMLInputElement {
      return this.$el.querySelector('input[type="file"]') as HTMLInputElement;
    }
  },

  methods: {
    imageUpload() {
      const el = this.inputField;

      if (!el) {
        return null;
      }

      if (!el.files || el.files.length === 0) {
        return null;
      }

      return el.files[0];
    },

    showPreview(file: File) {
      const reader = new FileReader();

      reader.onload = e => {
        const result = e.target?.result;

        if (!result || typeof result !== "string") {
          return;
        }

        this.preview = result;
      };

      reader.readAsDataURL(file);
    },

    async upload(file: File | undefined) {
      if (!file) {
        return;
      }

      const formData = new FormData();

      this.error = false;
      this.saving = true;

      this.showPreview(file);

      formData.append("picture", file, file.name);
      formData.append("something-else", "asdf");
      formData.append("_method", "patch");

      try {
        await axios.post("/ajax/account", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } catch {
        this.preview = null;
        this.error = true;
      } finally {
        this.saving = false;
      }
    },

    uploadFromDragAndDrop(event: DragEvent) {
      this.dragging = false;
      this.upload(event.dataTransfer?.files[0]);
    },

    uploadFromFileInput(event: InputEvent) {
      this.upload((event.target as HTMLInputElement).files?.[0]);
    }
  }
});
